// Some Utilities for parsing data that are used often

function parseListString(listName: string) {
    return listName.split('.');
}

function selectAllOrNone(value: boolean, currList: any[]) {
    if (currList && currList.length) {
        return new Array(currList.length).fill(value);
    }

    return [];
}

function selectAllOrNoneInternalProp(value: boolean, currList: any[], propName: string) {
    if (currList) {
        currList.forEach(element => {
            element[propName] = value;
        });
    }
}


function allOrNoneSelected(isAll: boolean, listName: string, selectedListName: string, baseRef: any) {
    if (!baseRef) {
        return;
    }
    let currList = baseRef;
    const parsedListString = parseListString(listName);
    parsedListString.forEach(element => {
        if (currList && currList[element]) {
            currList = currList[element];
        }
    });

    const parsedSelectionList = parseListString(selectedListName);
    let currSelections = baseRef;
    parsedSelectionList.forEach(element => {
        if (currSelections && currSelections[element]) {
            currSelections = currSelections[element];
        }
    });

    return currList.every((value: any, index: number) => {
        if (typeof currSelections[index] === 'boolean') {
            if (isAll !== currSelections[index]) {
                return false;
            }
        } else if (isAll) {
            return false;
        }
        return true;
    });
}

function allOrNoneSelectedInternalProp(value: boolean, currList: any[], propName: string) {
    if (currList) {
        return currList.every((element: any) => {
            if(typeof element[propName] === 'boolean') {
                return value === element[propName];
            } else {
                return value ? false : true;
            }
        });
    }

    return false;
}

export {
    allOrNoneSelected,
    allOrNoneSelectedInternalProp,
    selectAllOrNone,
    selectAllOrNoneInternalProp,
};


// WEBPACK FOOTER //
// ./src/UtilityFunctions/SelectAllOrNone.ts